'use client';
/** @jsxImportSource @emotion/react */

import type { DialogContentProps as MuiDialogContentProps } from '@mui/material/DialogContent';

import MuiDialogContent from '@mui/material/DialogContent';

type ExcludedMuiProps = '';

interface DialogContentProps
  extends Omit<MuiDialogContentProps, ExcludedMuiProps> {
  component?: React.ElementType;
}

export type { DialogContentProps };
export const DialogContent: React.FC<DialogContentProps> = MuiDialogContent;

DialogContent.displayName = 'DialogContent';
